const theme1 = (data) => {
  const node = data.node;
  const title = node.title;
  const color = data.color;

  return {
    id: "test-slide-1",
    elements: [
      {
        type: "shape",
        id: "4cbRxp",
        left: 0,
        top: 200,
        width: 472.6069221260816,
        height: 362.5,
        viewBox: [200, 200],
        path: "M 0 0 L 0 200 L 200 200 Z",
        fill: `${color}75`,
        fixedRatio: false,
        opacity: 0.7,
        rotate: 0,
      },
      {
        type: "shape",
        id: "ookHrf",
        left: 0,
        top: 0,
        width: 683.1891223733004,
        height: 485.32756489493204,
        viewBox: [200, 200],
        path: "M 0 0 L 0 200 L 200 200 Z",
        fill: `${color}c7`,
        fixedRatio: false,
        flipV: true,
        rotate: 0,
      },
      {
        type: "text",
        id: "idn7Mx",
        left: 355,
        top: 65.25,
        width: 585,
        height: 154.390625,
        lineHeight: 1.2,
        content:
          "<p><strong><span style='font-size:  112px'>Chat PPT</span></strong></p>",
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "7stmVP",
        left: 355,
        top: 253.25,
        width: 585,
        height: 56,
        content: `<p><span style='font-size:  24px'>${title}</span></p>`,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "line",
        id: "FnpZs4",
        left: 361,
        top: 238,
        start: [0, 0],
        end: [549, 0],
        points: ["", ""],
        color: `${color}c7`,
        style: "solid",
        width: 2,
      },
      {
        type: "shape",
        id: "TlaPz8zath",
        left: 785.6149567367121,
        top: 348.1149567367119,
        width: 170.7354758961681,
        height: 258.03461063040794,
        viewBox: [200, 200],
        path: "M 0 0 L 0 200 L 200 200 Z",
        fill: `${color}99`,
        fixedRatio: false,
        rotate: -90,
      },
    ],
    background: {
      type: "solid",
      color: `#fff`,
    },
  };
};

export default theme1;
